var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "73.000000pt",
    height: "65.000000pt",
    viewBox: "0 0 73.000000 65.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,65.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 340 l0 -240 235 0 c147 0 235 4 235 10 0 6 -86 11 -222 12 l-223 3 -3 228 c-1 140 -6 227 -12 227 -6 0 -10 -90 -10 -240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 520 c0 -5 9 -10 20 -10 11 0 20 -3 20 -7 0 -4 -70 -78 -156 -164 -89 -89 -154 -161 -150 -168 4 -6 71 55 163 149 85 88 159 160 164 160 5 0 9 -9 9 -20 0 -11 5 -20 10 -20 6 0 10 20 10 45 l0 45 -45 0 c-25 0 -45 -4 -45 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716 15 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemand);
export default __webpack_public_path__ + "static/media/demand.ed22d4cb0a19aab56662c8da291e96f3.svg";
export { ForwardRef as ReactComponent };